export default (object) => {
  const { properties: { value, currency } = {} } = object;

  if (value && currency) {
    window.uetq.push('event', { revenue_value: value, currency });
  }
};
